<template>
    <section class="ui-tag-status" :style="[textStyle, cursorCss, radiusCss]">
        <div class="body">
            <span v-if="!icon && setIcom" :style="colorCssComputed"/>
            <em v-if="icon && setIcom" :class="icon" :style="iconStyle"/>

            <div v-if="link" class="link" @click="go(link)">{{ text }}</div>
            <div v-else :style="fontColor">{{ text }}</div>
        </div>
    </section>
</template>

<script>
	import helpers from '@/mixins/helpers'
	export default {
		name: 'ui-tag-indicator',
		components: {},
		mixins: [helpers],
		props: {
			/**
			 * Utilize para definir o texto da tag.
			 */
			text: {
				type: [String, Number],
				default: 'Texto da Tag',
			},

			/**
			 * Utilize para definir a cor do indicador.
			 */
			color: {
				type: String,
				default: '#AFB9C8',
			},

			colorFont: {
				type: String,
				default: '#333D4F',
			},

			/**
			 * Utilize para definir o tamanho do texto da tag.
			 */
			textSize: {
				default: 11,
			},

			/**
			 * Utilize para definir o tamanho do texto da tag.
			 */
			radius: {
				default: 4,
			},

			link: {
				type: String,
				default: null,
			},

			icon: {
				type: String,
				default: '',
			},
			setIcom: {
				tyoe: Boolean,
				default: true
			},

			cursorStatus: {
				type: String,
				required: false,
			},
		},

		data() {
			return {}
		},

		computed: {
			colorCssComputed: {
				get() {
					return { backgroundColor: this.color }
				},
			},

			colorCss() {
				return { backgroundColor: this.color }
			},

			fontColor() {
				return { color: this.colorFont, fontWeight: 500 }
			},

			textStyle() {
				const height = parseInt(this.textSize)
				return {
					padding: height * 0.4 + 'px',
					paddingLeft: height * 0.5 + 'px',
					paddingRight: height * 0.5 + 'px',
					fontSize: height + 'px',
					lineHeight: height + 'px',
				}
			},

			iconStyle() {
				const height = parseInt(this.textSize)
				return {
					color: this.color,
					fontSize: (height * 1.25) + 'px',
					height: (height * 1.25) + 'px'
				}
			},

			radiusCss() {
				return { borderRadius: this.radius + 'px' }
			},

			cursorCss() {
				return { cursor: this.cursorStatus }
			},
		},

		methods: {
			go(link) {
				this.oldPanelLinkButton(link)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
